// import thSaraban from './font.js'
import font from '@/assets/fonts/font.js'

export const currentUser = state => state.users.main
// export const sidebar = state => state.app.sidebar
// export const size = state => state.app.size
// export const device = state => state.app.device
// export const isAuthen = state => state.users.main.success

// export const loadedOutsideBooks = (state) => {
//   return state.taibook.OutsideBooks.sort((bookA, bookB) => {
//     return bookB.id > bookA.id
//   })
// }
// export const featuredBooks = (state, getters) => {
//   return getters.loadedOutsideBooks.slice(0, 5)
// }
export const now = () => {
  let d = new Date()
  d = d.setUTCHours(d.getUTCHours() + (-d.getTimezoneOffset() / 60))
  let dd = new Date(d)
  return dd
}
export const nowString = () => {
  let d = new Date()
  d = d.setUTCHours(d.getUTCHours() + (-d.getTimezoneOffset() / 60))
  let dd = new Date(d)
  return dd.toISOString()
}

export const apiPath = () => {
  return process.env.VUE_APP_API_PATH
}

export const staticPath = () => {
  return process.env.VUE_APP_STATIC
}

export const fonts = () => {
  console.log('font', font.thSaraban)
  return [...font.thSaraban]
}
